import bg from '../assets/bg.png';
import G from '../assets/G.png';
import gallery01 from '../assets/gallery01.jpg';
import gallery02 from '../assets/gallery02.jpg';
import gallery03 from '../assets/gallery03.jpg';
import gallery04 from '../assets/gallery04.jpg';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.jpg';
import laurels from '../assets/laurels.jpg';
import award from '../assets/award.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.svg';

//Projects
import personalPortfolioImg from '../assets/projectImages/PersonalPortfolio.png'
import dorarmonGadgetImg from '../assets/projectImages/DoraemonGadgets.png'
import chessInsightsImg from '../assets/projectImages/ChessInsights.png'
import personalPortfoliov1Img from '../assets/projectImages/PersonalPortfoliov1.png'
import swarmRobotsImg from '../assets/projectImages/SwarmRobots.png'

//Skills
import canoe from '../assets/skillLogo/canoe.png'
import css from '../assets/skillLogo/css.png'
import docker from '../assets/skillLogo/docker.png'
import figma from '../assets/skillLogo/figma.png'
import flask from '../assets/skillLogo/flask.png'
import git from '../assets/skillLogo/git.png'
import html from '../assets/skillLogo/html.png'
import java from '../assets/skillLogo/java.png'
import javascript from '../assets/skillLogo/javascript.png'
import jira from '../assets/skillLogo/jira.png'
import mongo from '../assets/skillLogo/mongodb.png'
import otxstudio from '../assets/skillLogo/otxstudio.png'
import python from '../assets/skillLogo/python.png'
import react from '../assets/skillLogo/react.png'
import spark from '../assets/skillLogo/spark.png'
import copilot from '../assets/skillLogo/copilot.png'
import cursor from '../assets/skillLogo/cursor.png'
import typescript from '../assets/skillLogo/typescript.png'
import linux from '../assets/skillLogo/linux.png'
import sql from '../assets/skillLogo/sql.png'
import postgresql from '../assets/skillLogo/postgresql.png'
import aws from '../assets/skillLogo/aws.png'
import maven from '../assets/skillLogo/maven.png'
import selenium from '../assets/skillLogo/selenium.png'
import postman from '../assets/skillLogo/postman.png'
import jenkins from '../assets/skillLogo/jenkins.png'

export default {
  bg,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,  logo, menu,
  overlaybg,  spoon,
  welcome,  laurels,
  award,  sign,
  quote,  gericht,
  personalPortfolioImg,
  dorarmonGadgetImg,
  chessInsightsImg,
  personalPortfoliov1Img,
  swarmRobotsImg,

  canoe,  css,  docker,  figma,  flask,  git,  html,  java,
  javascript,  jira,  mongo,  otxstudio,  python,  react,
  spark,  cursor,  copilot,  typescript,  linux,
  aws, sql, postgresql, maven, selenium, postman, jenkins
};
